/*
 * @FileAuthor: ghy
 * @Date: 2023-09-20 19:22:52
 * @Description: hook
 */

const Event = require('../event/index');

/**
 * @description 初始化hook
 * @param { Ext } ext 插件实例
 */
function initHook(ext) {
  Object.values(Event).forEach((value) => {
    const hookCb = [];
    Object.defineProperty(ext, value, {
      set(cb) {
        hookCb.push(cb);
      },
      get() {
        return hookCb;
      },
    });
  });
}

module.exports = initHook;
